import React  from 'react';
import ReactDOM from 'react-dom';
import AccountInformation from 'src/scripts/templates/customers/components/AccountInformation';

const renderAccountInfo = () => {
  return () => {
    const mountAccountInfo = document.querySelector('[react-render-target="account-info"]');

    if (mountAccountInfo) ReactDOM.render(<AccountInformation />, mountAccountInfo);
    else console.warn('missing render target on desktop: AccountInformation');

  };
};
export const initAccountInfoForm = renderAccountInfo();